import styled from '@emotion/styled';
import { EMOJI_EXPRESSION } from 'constants/constants';
import { SurveyScalingIcon } from 'constants/svgIcons';
import { StateHandle } from 'modules/Course/Unit/components/QuestionType/surveyScaling';
import React, { useContext, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import styles from 'styles/Question.module.scss';
const InputTypes = ({ name = '' }) => {
  const {
    questionArray,
    setQuestionArray,
    question,
    item,
    type = 'radio',
    setScaling,
    ...props
  } = useContext(StateHandle);

  const { setValue } = useFormContext();

  const handleAnswerValue = (answer) => {
    let array = [...questionArray];
    questionArray?.forEach((element, index) => {
      if (element._id === question?._id) {
        let obj = { ...element };
        obj.answerValue = answer;
        array.splice(index, 1, obj);
        setQuestionArray(array);
      }
    });
  };

  const handelSplice = (ID) => {
    let array = [...questionArray];
    questionArray?.forEach((element, index) => {
      if (element._id === ID && element?.answerValue?.options?.length) {
        let obj = { ...element };
        obj.answerValue = '';
        array.splice(index, 1, obj);
        setQuestionArray(array);
      }
    });
  };

  function updateAtIndexToTrue(array, index) {
    const updatedArray = array.map((_, i) => i === index);
    return updatedArray;
  }

  function validationCheck(params) {
    const RESULT = params.every((dt) => dt?.value.some((vl) => vl));
    return RESULT;
  }

  const handleOnChange = (data, checked) => {
    let updatedState = {};
    let newArray = [...props?.scaling?.options];
    let ArrayValues = [...newArray[item?.questionIndex]?.value];

    if (props?.isMulti) {
      ArrayValues[item?.index] = checked;
      newArray[item?.questionIndex] = {
        question: item?.value,
        value: ArrayValues,
      };
      updatedState = {
        ...props?.scaling,
        options: newArray,
      };
      setScaling((preVal) => ({
        ...preVal,
        options: newArray,
      }));
    } else {
      let singleSelect = newArray.map((dt, index) =>
        index === item?.questionIndex
          ? { ...dt, value: updateAtIndexToTrue(ArrayValues, item?.index) }
          : { ...dt },
      );
      updatedState = {
        ...props?.scaling,
        options: singleSelect,
      };
      setScaling((preVal) => ({
        ...preVal,
        options: singleSelect,
      }));
    }

    if (validationCheck(updatedState?.options)) {
      questionArray && handleAnswerValue(updatedState);
      setValue('scalePointsList', updatedState);
    } else {
      questionArray && handelSplice(question?._id);
    }
  };

  const buttonType = {
    radio: <InputRadioButton name={name} handleOnChange={handleOnChange} />,
    checkbox: <InputCheckBox name={name} handleOnChange={handleOnChange} />,
    emoji: <InputEmoji name={name} handleOnChange={handleOnChange} />,
  };

  const compoenent = buttonType[type];
  return <>{compoenent}</>;
};

export default InputTypes;

const InputRadioButton = ({ name, handleOnChange }) => {
  const { item } = useContext(StateHandle);
  const colorStatus = useSelector(getColor);
  const themeStatus = useSelector(getThemeColor);

  const LABEL = styled.label`
    & > span::before {
      border-color: ${item?.checked ? themeStatus : 'gray'} !important;
    }
  `;

  const SPAN = styled.span`
    padding-left: 0px !important;
    margin-left: 10px;
    position: relative;
    & > input {
      position: absolute;
    }
    &::after {
      background: ${item?.checked ? themeStatus : 'gray'} !important;
      opacity: ${item?.checked ? '1' : '0'} !important;
      transform: scale(${item?.checked ? '1' : '0'}) !important;
    }
    & > span {
      opacity: 0;
    }
  `;
  return (
    <LABEL className={`${styles.radio} mb-0`}>
      <Input
        name={name}
        type={'radio'}
        value={item.value}
        checked={item?.checked}
        onClick={() => {
          handleOnChange(item.value, !item?.checked);
        }}
        onChange={() => void 0}
      />
      <SPAN>
        <span>radio</span>
      </SPAN>
    </LABEL>
  );
};

const InputCheckBox = (props) => {
  const { name, handleOnChange } = props;
  const colorStatus = useSelector(getColor);
  const themeStatus = useSelector(getThemeColor);

  const { item } = useContext(StateHandle);
  const LABEL = styled.label`
    margin-left: 20px;
    position: relative;
    & > input {
      position: absolute;
      accent-color: ${themeStatus};
    }
  `;
  const SPAN = styled.span`
    opacity: 0;
  `;
  return (
    <LABEL>
      <Input
        name={name}
        type={'checkbox'}
        value={item.value}
        checked={item?.checked}
        onChange={({ target }) => handleOnChange(item.value, target.checked)}
      />
      <SPAN>.</SPAN>
    </LABEL>
  );
};

const InputEmoji = (props) => {
  const { name, handleOnChange } = props;
  const colorStatus = useSelector(getColor);
  const themeStatus = useSelector(getThemeColor);
  const { item } = useContext(StateHandle);

  let emojiName;

  if (
    (item?.currentArray?.length === 2 && item?.index === 1) ||
    (item?.currentArray?.length === 3 && item?.index === 2) ||
    (item?.currentArray?.length === 4 && item?.index === 3)
  ) {
    emojiName = EMOJI_EXPRESSION.at(-1);
  } else {
    emojiName = EMOJI_EXPRESSION[item?.index];
  }

  const LABEL = styled.label`
    width: 50px;
    height: 50px;
    cursor: pointer;
    transition: border 200ms ease-in-out;
    outline: 2px solid ${item?.checked ? themeStatus : 'transparent'};
    border-radius: 50%;
    outline-offset: 2px;
    &:hover {
      outline-color: ${themeStatus};
    }
  `;

  return (
    <LABEL onClick={() => handleOnChange(item.value, !item?.checked)}>
      {SurveyScalingIcon(emojiName, {
        border: '',
        fillColor: '',
        height: '100%',
        width: '100%',
      })}
    </LABEL>
  );
};
